import Button from "@mui/material/Button";
import CardActions from "@mui/material/CardActions";
import { StackProps } from "@mui/material/Stack";
import { useFormik } from "formik";
import {
	LineSimpleConfigs,
	SymbolStyle,
} from "~ui-components/types/__generated/gql/graphql";
import { LineStyle } from "../line-style";

type Props = StackProps & {
	form: ReturnType<typeof useFormik<LineSimpleConfigs>>;
};

const defaultSymbolStyle: SymbolStyle = {
	basic: null,
	fill: null,
	isGraphic: null,
	name: null,
	stroke: null,
};

export const LineSimpleStyle = (props: Props) => {
	const { form } = props;
	const {
		values: { symbolStyle },
		handleSubmit,
	} = form;

	return (
		<form onSubmit={handleSubmit}>
			<LineStyle
				value={{ symbolStyle: symbolStyle ?? defaultSymbolStyle }}
				onChange={(next) => form.setFieldValue("symbolStyle", next.symbolStyle)}
			/>
			<CardActions sx={{ justifyContent: "flex-end", p: 0, mt: 2 }}>
				<Button
					color="secondary"
					type="reset">
					Cancel
				</Button>
				<Button
					variant="contained"
					type="submit">
					Save changes
				</Button>
			</CardActions>
		</form>
	);
};
